import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchMessageChannelsQuery } from 'api/queries';

type MessageChannelsResponse = {
  messageChannels: { id: number; name: string; creatorUserId: string; updatedAt: string }[];
};

/**
 * Fetches message channels to be used in Entry/Exit/Hold Rules and Start Tile Resource value
 * @returns {object} An object containing didError, isLoading, messageChannels[]
 */
export const useMessageChannels = () => {
  const { data, error, networkStatus } = useGraphql<MessageChannelsResponse>(
    fetchMessageChannelsQuery,
    {
      fetchPolicy: 'cache-first',
    },
  );

  const isLoading = networkStatus < 7;
  const didError = !!error;

  return {
    didError,
    isLoading,
    messageChannels: (!didError && !isLoading && data?.messageChannels) || [],
  };
};
